"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _Input = _interopRequireDefault(require("../../../Input"));
var _dialer = require("../../../../icons-react/dialer");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Dial = /*#__PURE__*/function (_React$PureComponent) {
  function Dial(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Dial);
    _this = _callSuper(this, Dial, [props]);
    _this.state = {
      value: '',
      isOpen: false
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleToggle = _this.handleToggle.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(Dial, _React$PureComponent);
  return (0, _createClass2["default"])(Dial, [{
    key: "handleChange",
    value: function handleChange(_ref) {
      var target = _ref.target;
      this.setState({
        value: target.value
      });
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(ev) {
      var onTone = this.props.onTone;
      var isAcceptedKey = /[0-9|*|#]/g.test(ev.key);
      if (isAcceptedKey) {
        onTone(ev.key);
      } else {
        ev.preventDefault();
      }
    }
  }, {
    key: "handleToggle",
    value: function handleToggle() {
      this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        isOpen = _this$state.isOpen,
        value = _this$state.value;
      return /*#__PURE__*/_react["default"].createElement(StyledDial, this.props, /*#__PURE__*/_react["default"].createElement(StyledDialIcon, {
        onClick: this.handleToggle
      }, /*#__PURE__*/_react["default"].createElement(_dialer.Dial, null)), /*#__PURE__*/_react["default"].createElement(StyledInput, {
        open: isOpen,
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown,
        placeholder: "\u0414\u043E\u0431. \u043D\u043E\u043C\u0435\u0440",
        value: value
      }));
    }
  }]);
}(_react["default"].PureComponent);
Dial.propTypes = {
  className: _propTypes["default"].string,
  onTone: _propTypes["default"].func.isRequired
};
Dial.defaultProps = {
  className: ''
};
var StyledDial = _styledComponents["default"].div.withConfig({
  displayName: "Dial__StyledDial",
  componentId: "sc-qj1btj-0"
})(["background-color:#17181a;border:1px solid #4d4d4d;border-radius:20px;display:flex;height:40px;"]);
var StyledDialIcon = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "Dial__StyledDialIcon",
  componentId: "sc-qj1btj-1"
})(["background-color:transparent;border:none;box-sizing:border-box;cursor:pointer;display:flex;height:40px;position:absolute;width:40px;z-index:2;> svg{margin:auto;rect{stroke:#4d4d4d;}}"]);
var StyledInput = (0, _styledComponents["default"])(_Input["default"]).withConfig({
  displayName: "Dial__StyledInput",
  componentId: "sc-qj1btj-2"
})(["background-color:transparent;border:none;box-sizing:border-box;color:#fff;font-size:14px;padding:0 0 0 40px;width:0px;line-height:38px;transition:width 300ms;transform:translate3d(0,0,0);", ""], function (props) {
  return props.open && "\n    padding-right: 15px;\n    width: 147px;\n  ";
});
var _default = exports["default"] = Dial;